import { Component, OnInit, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { get } from 'lodash';
import * as moment from 'moment';
import { AuthService } from '@base/shared/services';

@Component({
  selector: 'eyrus-header-banner',
  templateUrl: './header-banner.component.html',
  styleUrls: ['./header-banner.component.sass']
})
export class HeaderBannerComponent implements OnInit {

  @Input() message: String = '';
  @Input() showClose: Boolean = false;
  @Input() userType: String = 'submitter';
  @Input() bannerType: String = 'trial';
  @Input() account: any = {};
  @Output() closed: Subject<any> = new Subject<any>();

  constructor(
    private auth: AuthService
  ) { }

  ngOnInit() {
  }

  closeAction() {
    this.closed.next(true);
  }

  get accountPermissions() {
    return this.auth.user['permissions'];
  }

  get remainingDays() {
    const endDateLabel = this.bannerType === 'trial' ? 'trialEndDateTimeUtc' : 'lockoutDateTimeUtc';
    const endDate = get(this.account, endDateLabel);
    const daysLeft = get(this.account, 'daysLeftInTrial') || 0;

    if (this.bannerType === 'locked') {
      const today = moment();
      const diff = moment(endDate).diff(today, 'days');
      return diff;
    }

    // console.log(daysLeft)
    // if (!endDate)
    //   return;

    // const today = moment();
    // const diff = moment(endDate).diff(today, 'days');

    return daysLeft;
  }

}
